module.exports = {"id":"217805","name":"Alexis Martín Arias","rating":"72","photo":"./data/images/photos/2/217805.png","club":{"name":"G. La Plata","logo":"./data/images/clubs/G.LaPlata.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexisMartinArias0.json
// module id = 272
// module chunks = 0